export default "__VITE_ASSET__EvLtR$nu__"